import { z } from "zod/v3";

const impersonateFragmentSchema = z.object({
  token: z.string().min(1),
  expiresAt: z.string().min(1),
  adminEmail: z.string().min(1),
  userLoginId: z.coerce.number().int().positive().optional(),
});

export type ImpersonateFragment = z.infer<typeof impersonateFragmentSchema>;

export function parseImpersonateFragment(hash: string): ImpersonateFragment | null {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const readParam = (name: string) => params.get(name) ?? undefined;

  const parsed = impersonateFragmentSchema.safeParse({
    token: readParam("token"),
    expiresAt: readParam("expiresAt"),
    adminEmail: readParam("adminEmail"),
    userLoginId: readParam("userLoginId"),
  });

  if (!parsed.success) {
    return null;
  }

  return parsed.data;
}
